export const CATEGORIES = [
  {
    id: 'hot-take',
    name: 'Hot Take',
    icon: '🎙️',
    color: '#EF4444',
    description: 'Bold, controversial opinions'
  },
  {
    id: 'thinking-out-loud',
    name: 'Thinking Out Loud',
    icon: '🧠',
    color: '#8B5CF6',
    description: 'Exploratory, unfinished thoughts'
  },
  {
    id: 'personal-story',
    name: 'Personal Story',
    icon: '🫂',
    color: '#10B981',
    description: 'Experience-based perspectives'
  },
  {
    id: 'nuanced-take',
    name: 'Nuanced Take',
    icon: '🧩',
    color: '#3B82F6',
    description: 'Balanced, thoughtful analysis'
  },
  {
    id: 'devils-advocate',
    name: "Devil's Advocate",
    icon: '🔍',
    color: '#F59E0B',
    description: 'Playing the opposite side'
  }
];